<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" id="modal-form-estado">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Actualizar Estado</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="estado">Estado</label>
              <select
                id="estado"
                class="form-control form-control-sm"
                v-model="form_estado.estado"
                :class="
                  $v.form_estado.estado.$invalid ? 'is-invalid' : 'is-valid'
                "
              >
                <option value="">Seleccione...</option>
                <option
                  v-for="estado in $parent.listasForms.estados"
                  :key="estado.numeracion"
                  :value="estado.numeracion"
                >
                  {{ estado.descripcion }}
                </option>
              </select>
              <div class="error" v-if="!$v.form_estado.estado.required">
                Seleccione un estado
              </div>
            </div>
            <div class="form-group">
              <label for="justificacion">Justificacion</label>
              <textarea
                v-model="form_estado.justificacion"
                cols="30"
                rows="5"
                class="form-control form-control-sm"
                :class="
                  $v.form_estado.justificacion.$invalid
                    ? 'is-invalid'
                    : 'is-valid'
                "
              ></textarea>
              <div class="error" v-if="!$v.form_estado.justificacion.required">
                Ingrese una Justificacion
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-primary"
              v-show="!$v.form_estado.$invalid"
              @click="save()"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "RemitoEstado",
  data() {
    return {
      form_estado: {
        estadoAnt: null,
        estado: null,
        justificacion: null,
      },
    };
  },
  validations: {
    form_estado: {
      estado: {
        required,
      },
      justificacion: {
        required,
        minLength: minLength(10),
      },
    },
  },
  methods: {
    llenar_modal(id, estado) {
      this.form_estado.id = id;
      this.form_estado.estadoAnt = estado;
      this.form_estado.estado = estado;
      this.form_estado.justificacion = null;
    },
    save() {
      let me = this;
      this.$parent.cargando = true;
      axios
        .put("/api/argentina/remitos/" + this.form_estado.id, this.form_estado)
        .then(async () => {
          this.$parent.cargando = false;
          this.$refs.closeModal.click();
          await this.$parent.getIndex();
          await this.$parent.getGrafica();
          this.$swal({
            icon: "success",
            title: "El estado se actualizó exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((e) => {
          this.$parent.cargando = false;
          let res = Object.assign({}, e);
          this.$swal({
            icon: "error",
            title:
              "Ocurrio un error, vuelva a intentarlo..." +
              (res.response?.data?.mensaje || ""),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },
  },
};
</script>
